import * as types from "../actions/actionTypes";
import initialState from "../store/initialState";
import mergeDeep from "../util/mergeDeep";
import { orderByPropertyName } from "../util/orderBy";

export default function referentieReducer(state = initialState.referentie, action) {
	switch (action.type) {
		case types.REFERENCES_LOADED: {
			let referenceData = {};

			Object.keys(action.body).forEach(key => {
				if (key === "postcodes" || key === "gemeentes" || key === "klachtenBronnen" || key === "initiatieven") {
					referenceData[key] = Object.keys(action.body[key]).map(k => { return { value: action.body[key][k].id, label: action.body[key][k].naam }; });
				}
				else {
					referenceData[key] = Object.keys(action.body[key]).map(k => { return { value: k, label: action.body[key][k] }; });
				}
			});

			referenceData['gemeentes'] = orderByPropertyName(referenceData['gemeentes'], 'label');
			referenceData['postcodes'] = orderByPropertyName(referenceData['postcodes'], 'label');

			return mergeDeep({}, referenceData);
		}

		default:
			return state;
	}
}